// 상단 이미지 2개, 혜택기간, form, 신청하기 , 푸터
// 질문 1개 - 이름 & 번호
// 특이사항 - randingstyle5와 혜택기간위치만 다름

import React, { useEffect, useState } from "react";
// import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { validateName, validatePhoneNumber } from "../utils/validation";
import { handleFormSubmit } from "../handlers/formHandlers";
import PhoneNumberInput from "../components/PhoneNumberInput";
import BenefitPeriod from "../components/BenefitPeriod";
import PrivacyPolicyAgree from "../components/PrivacyPolicyAgree";
import {
  options,
  phoneFirstOptions,
  prohibitedWords,
} from "../utils/dummyData";

import "./randingStyle1.scss";
import SelectEvents from "../components/SelectEvents";
import PrivacyContent from "./PrivacyContent";

function RandingStyle4({
  periodType,
  urlCode,
  urlCodeSettingId,
  img1Path,
  img2Path,
  img3Path,
  img4Path,
  img5Path,
  img6Path,
  img7Path,
  numberColor,
  benefitInfoPosition,
  formFieldColor,
  qBoxBackgroundColor,
  keepBTN,
  privacyMessage,
  postBTN,
  companyName,
  privacyCompanyName,
  footerPath,
  // 랜딩 별로 태그 설정인 경우

  apiUrl,
  adTarget,
  treatments,
  kakaotalk,
  carrotTag,
}) {
  const navigate = useNavigate();
  const privacyName = privacyCompanyName || companyName || "수집주체명";
  // 상태 관리
  const [name, setName] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false); // 버튼 상태 관리
  const [phoneNumber, setPhoneNumber] = useState({
    first: "",
    second: "",
    third: "",
  });
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [isAgreed, setIsAgreed] = useState(false);
  const [isPrivacyPolicyModal, setIsPrivacyPolicyModal] = useState(false);
  const [submitCount, setSubmitCount] = useState(0);

  // 유효성 검사
  const validateInput = () => {
    return (
      validateName(name, prohibitedWords) && validatePhoneNumber(phoneNumber)
    );
  };

  // 이벤트 핸들러
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/[^0-9]/g, "");

    setPhoneNumber((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  const handleSelectImplant = (option) => {
    setSelectedOption(option);
  };

  const togglePrivacyPolicyModal = () => {
    setIsPrivacyPolicyModal(!isPrivacyPolicyModal);
  };

  const handleSubmit = () => {
    // selectedValue가 빈 값일 경우 treatments의 첫 번째 value로 설정
    const finalSelectedValue =
      selectedValue && selectedValue !== ""
        ? selectedValue
        : treatments && treatments.length > 0
        ? treatments[0].value
        : null; // treatments가 비어 있는 경우 null

    if (treatments && !finalSelectedValue) {
      console.error("선택 가능한 값이 없습니다.");
      return; // treatments가 비어 있는 경우 처리
    }

    handleFormSubmit({
      name,
      phoneNumber,
      selectedOption,
      isAgreed,
      submitCount,
      setSubmitCount,
      validateInput,
      urlCode,
      urlCodeSettingId,
      navigate,
      setIsSubmitting,

      apiUrl,
      selectedValue: finalSelectedValue, // 업데이트된 selectedValue 전달
      kakaotalk,
      carrotTag,
    });
  };

  return (
    <div className={`form-container`}>
      <div className="step2">
        {img1Path && <img src={img1Path} alt="임플란트 고민중이세요?" />}
        {img2Path && <img src={img2Path} alt="임플란트 고민중이세요?" />}
        {img3Path && <img src={img3Path} alt="임플란트 고민중이세요?" />}
        {img4Path && <img src={img4Path} alt="임플란트 고민중이세요?" />}
        {img5Path && <img src={img5Path} alt="임플란트 고민중이세요?" />}
        {img6Path && <img src={img6Path} alt="임플란트 고민중이세요?" />}
        {img7Path && <img src={img7Path} alt="임플란트 고민중이세요?" />}
        <div
          className={`qBox ${qBoxBackgroundColor && "backgroundColor"}`}
          style={
            qBoxBackgroundColor && { backgroundColor: qBoxBackgroundColor }
          }
        >
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
          <form
            className="formBox"
            onSubmit={(e) => {
              e.preventDefault(); // 기본 제출 동작 방지
              handleSubmit(); // 기존 handleSubmit 호출
            }}
          >
            {benefitInfoPosition === "top" && (
              <p className="benefitInfo">
                <BenefitPeriod periodType={periodType} />
                <br />
                이벤트 대상자 : {adTarget ? adTarget : "해당 매체 이용자"}
              </p>
            )}
            {treatments && treatments.length > 1 && (
              <div
                className={`formField ${
                  formFieldColor === "white" ? "white" : ""
                }`}
              >
                <label htmlFor="name">혜택선택</label>

                <SelectEvents
                  selectedValue={selectedValue}
                  setSelectedValue={setSelectedValue}
                  treatments={treatments}
                  formFieldColor={formFieldColor}
                  placeholderText="선택하세요"
                  propsStyle={{ border: "none", padding: 0, margin: 0 }}
                />
              </div>
            )}
            <div
              className={`formField ${
                formFieldColor === "white" ? "white" : ""
              }`}
            >
              <label htmlFor="name">이름</label>
              <input
                type="text"
                id="name"
                maxLength="10"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="이름을 입력해주세요."
              />
            </div>
            <PhoneNumberInput
              phoneNumber={phoneNumber}
              phoneFirstOptions={phoneFirstOptions}
              handlePhoneNumberChange={handlePhoneNumberChange}
              formFieldColor={formFieldColor}
            />
            <PrivacyPolicyAgree
              isAgreed={isAgreed}
              setIsAgreed={setIsAgreed}
              togglePrivacyPolicyModal={togglePrivacyPolicyModal}
              privacyMessage={privacyMessage}
            />
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            {/* 전송폼 세분화 */} {/* 전송폼 세분화 */} {/* 전송폼 세분화 */}
            {isPrivacyPolicyModal && (
              <div className="modalOverlay" onClick={togglePrivacyPolicyModal}>
                <div
                  className="privacyPolicyContent"
                  onClick={(e) => e.stopPropagation()}
                >
                  <PrivacyContent companyName={privacyName} />
                </div>
              </div>
            )}
            {benefitInfoPosition === "bottom" && (
              <p className="benefitInfo">
                <BenefitPeriod periodType={periodType} />
                <br />
                이벤트 대상자 : {adTarget ? adTarget : "해당 매체 이용자"}
              </p>
            )}
            <button
              type="submit"
              className="sendBtnBox"
              disabled={isSubmitting}
            >
              <img src={postBTN} alt="신청하기" />
            </button>
          </form>
        </div>
      </div>

      {footerPath && (
        <div className="footer">
          {footerPath && <img src={footerPath} alt="푸터" />}{" "}
        </div>
      )}
    </div>
  );
}

export default RandingStyle4;
